import React, {useState, useEffect} from 'react';
import {Container, Grid, Backdrop, Typography, CircularProgress, ListItem, ListItemIcon, ListItemText, Button} from '@material-ui/core/';
import {NavigateNext} from '@material-ui/icons';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import { useHistory } from "react-router-dom";
import {AccountCircle, Email, Filter1, VpnKey } from '@material-ui/icons';
import Form from 'components/Form/FormTwoColumns';
import DatosCiudadano from './DatosCiudadano'
import AgregarRegistrosDeContactosDeLaSolicitud from './DialogoAgregarRegistroDeContacto'
import {functions} from 'constants/index';
import ApiServices from 'services/ApiServices';
import { showMessagePersonalizedPosition, showMessagePersonalizedToast, showMessageSuccessSimple } from 'services/SweetAlert';
import { Alert } from '@material-ui/lab';
import DialogLoadingMessage from 'components/BackDrop';
function DatosSolicitudYProcesoDeContacto(props) {
    let history = useHistory();
    const classes = useStyles(),
        [loadingMessage, setLoadingMessage] = useState({loading:false, title:''}),        
        [open, setOpen] = useState(false),
        [nroBoleta, setNroBoleta] = useState(''),
        [limiteDeRegistroDeContactos, setLimiteDeRegistroDeContactos] = useState(false);

    const [elements,setElements] = useState({
        titleObservacion:{
            idelement: "titleObservacion",title:'Observaciones', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },    
            observaciones: {
                idelement: "observaciones",  value:'', label: "Observación", pattern:"^[\\w1-9 _Ññ.,!¡\"#$%&/()=¿?'@*-]{0,1024}$", minWidth: 1100,
                validators: ['requireds'], errorMessages:['Máximo 50 carácteres'], isError:false, elementType:'input', showInputControl: true,
            },            
        titlecContraseña:{ idelement: "titlecContraseña", title:'Ingrese la contraseña de firma electrónica', validators: ['requireds'], isError:true, position:"center", value: "", isError:false, elementType:'title'},        
            contraseña: {  
                idelement: "contraseña",  value:'', label: "Contraseña *", finalRequiredLength: 50,
                pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,50}$", 
                validators: ['required'], errorMessages:['Contraseña requerida'], isError:false, elementType:'password' 
            },
    });
    const nextStepRechazarSolicitudRegistroDeContacto=()=>{
        props.SOLICITUD_EMPADRONAMIENTO_SET_STEP_PROCESO_REGISTRO_DE_CONTACTO(props.stepperProcesoRegistroDeContacto+1);
        props.SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_PROCESO_REGISTRO_DE_CONTACTO(true)
    };

    const AbrirDialogoRegistroDeContacto=()=>{
        setOpen(true)
    };    
    const CerrarDialogoRegistroDeContacto=()=>{
        setOpen(false)
    };    

    const Cerrar=()=>{
        props.handleClose()
        props.SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_TSE_VIRTUAL_ENVIADA('')
    };    

    const ProcesarSolicitud= async()=>{  
        let saveData = {
            
            idSolicitud: props.datosCiudadanoTable.idSolicitud, nroBoleta: nroBoleta, departamento: props.datosCiudadanoTable.departamentoResidencia?.id, 
            municipio: props.datosCiudadanoTable.municipioResidencia?.id?.id, comunidad: props.datosCiudadanoTable.comunidadResidencia?.codigoComunidad, 
            cenVotacion: props.datosCiudadanoTable?.comunidadResidencia?.idCenVotacion, direccion: props.datosCiudadanoTable?.direccion, 
            numeroZona: props.datosCiudadanoTable?.numeroZona, numeroCasa: props.datosCiudadanoTable?.numeroCasa, base64ConstanciaParaHuella:'', codigoCVE:'',
            password: elements.contraseña.value, profesion: props.datosCiudadanoTable?.complementoSolicitudesEmpadronamiento?.profesionName?.id,
            observaciones: elements.observaciones.value ? elements.observaciones.value.trim() : '',
        }
        // console.log('saveData: ', saveData)
        let allGood = true;
        allGood = functions.checkIsEmptyWhenRequiredElement(
            elements,
            setElements
        );        
        if(allGood){
            setLoadingMessage({loading: true, title:'Procesando solicitud TSE Virtual. Espere un momento ...'})
            try{
                const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.autorizar(saveData);
                if(response.error!==null){
                    showMessagePersonalizedPosition('warning','Oopss!', response.error.message,'center')
                }else{
                    Cerrar()
                    props.actualizarTabla()        
                    // showMessagePersonalizedPosition('success','BIEN!', response.data?.message,'center')
                    showMessagePersonalizedPosition(response.data.tipo, ((response.data.tipo === "success") ? "¡BIEN!" : (response.data.tipo === "warning") ? "Advertencia": ''), response.data.message);
                    props.ObtenerTotalDeSolicitudesPendientesDeRealizar()
                }   
            }catch(exception){
                if (exception.status===404) {
                    showMessagePersonalizedPosition('error', '¡Oops!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
                else {
                    showMessagePersonalizedPosition('error', '¡Oops! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
                }
            }   
            setLoadingMessage({loading: false, title:''})                        
        }         
    };    

    // const [buttonList,setButtonList]= React.useState({
    //     "next":{"label":"Asignar Residencia","icon": <NavigateNext />,"callback":ProcesarSolicitud,"loading":false, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",},
    // });

    useEffect(() => {
        if(props.limiteRegistroDeContacto === 2) setLimiteDeRegistroDeContactos(true);
        else setLimiteDeRegistroDeContactos(false);
    },[props.limiteRegistroDeContacto])

    return (
        <div className={classes.root}>
            <div className={classes.colorComponente}>
                <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
                <Grid >
                    <Grid className={classes.marginText} item xs={12} > 
                        <DatosCiudadano open={props.open} setNroBoleta={setNroBoleta}/>
                    </Grid>
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div> <br/>
            <div  className={classes.colorComponente}>
                <Grid container >
                    {limiteDeRegistroDeContactos ? (
                        <Grid className={classes.AlignAlerta} item xs={12}>
                            <Alert  variant="outlined" severity="warning">
                                ¡Oops!, Ha llegado al limite de Registro de Contacto, por lo tanto, la solicitud
                                no podrá ser procesada, se procederá únicamente a rechazar la misma.
                            </Alert>
                        </Grid>                                                               
                    ):''}                    
                    <Grid className={classes.AlignTable} item xs={12}>
                        <Form   elements= {elements} BotonCerrar={Cerrar} 
                            BotonAgregarRegistroDeContacto={AbrirDialogoRegistroDeContacto} BotonCancelar={nextStepRechazarSolicitudRegistroDeContacto}
                            BotonProcesar={ProcesarSolicitud} disabled={limiteDeRegistroDeContactos}
                        />
                    </Grid>                                       
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div><br/>
            {open ? <AgregarRegistrosDeContactosDeLaSolicitud open={open} handleClose={CerrarDialogoRegistroDeContacto}/> : ''}            
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosSolicitudYProcesoDeContacto);